import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { ApiService } from "@bitwarden/common/abstractions/api.service";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { UserVerificationService } from "@bitwarden/common/abstractions/userVerification/userVerification.service.abstraction";
import { Verification } from "@bitwarden/common/types/verification";
import { BasiqMapper } from "@bitwarden/web-vault/app/services/syncing/basiq/mappers/basiq.mapper";
import { SideMenuService } from "@bitwarden/web-vault/app/services/menu/side-menu.service";

import { StoreLoaderService } from "@bitwarden/web-vault/app/services/dali/store.loader.service";
import { GlossRoutes } from "@bitwarden/web-vault/app/models/enum/routes.enum";

@Component({
  selector: "app-purge-vault",
  templateUrl: "purge-vault.component.html",
})
export class PurgeVaultComponent {
  private storeLoader = inject(StoreLoaderService);

  masterPassword: Verification;
  formPromise: Promise<unknown>;

  constructor(
    private apiService: ApiService,
    private i18nService: I18nService,
    private platformUtilsService: PlatformUtilsService,
    private userVerificationService: UserVerificationService,
    private router: Router,
    private logService: LogService,
    private glossMenuService: SideMenuService,
    private dialogRef: MatDialogRef<PurgeVaultComponent>,
  ) {}

  async submit() {
    try {
      this.formPromise = this.userVerificationService
        .buildRequest(this.masterPassword)
        .then((request) => this.apiService.postPurgeCiphers(request));

      await this.formPromise;

      await this.clearState();
      this.platformUtilsService.showToast("success", null, this.i18nService.t("vaultPurged"));

      this.router.navigate([GlossRoutes.Views]);
      this.dialogRef.close();
    } catch (e) {
      this.logService.error(e);
    }
  }

  private async clearState() {
    this.storeLoader.clearStores();
    await this.storeLoader.initializeStores();
  }
}
